import { render, staticRenderFns } from "./TagSetupConversionAction.vue?vue&type=template&id=654a994b&scoped=true&"
import script from "./TagSetupConversionAction.vue?vue&type=script&lang=js&"
export * from "./TagSetupConversionAction.vue?vue&type=script&lang=js&"
import style0 from "./TagSetupConversionAction.vue?vue&type=style&index=0&id=654a994b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654a994b",
  null
  
)

export default component.exports